import React from 'react'
import { FaShoppingCart, FaStar } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import './ProductSlider.css'
import { zoomIn } from "../../motion";
import { motion } from "framer-motion";

const Product = (props) => {
  const navigate = useNavigate()
  const handleClick = () => {
    navigate(`Products/${props.idx}`)
  }
  const getShortDescription = (description, maxLength = 40) => {
    if (description.length <= maxLength) {
      return description;
    }
    return `${description.substring(0, maxLength)}...`;
  };
  return (
    <>
      <a href={`Products/${props.idx}`}>
        <div className='card'>
          <motion.img
            variants={zoomIn}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 0.2 }}
            className='product--image'
            src={props.url} alt="productimage"
          />
          <div className="detail">
            <h2>{props.name}</h2>
            <p className='prod  uct-p'>{getShortDescription(props.description)}</p>
          </div>
          <p className="price"><FaStar color='#fed02f' /><FaStar color='#fed02f' /><FaStar color='#fed02f' /><FaStar color='#fed02f' /></p>
          <p className="price">₹{props.price}</p>
          <div className="cart">

            <p>
              <button> <FaShoppingCart /> Add To Cart </button>
            </p>
          </div>
        </div>
      </a>

    </>

  )
}

export default Product
